import React from 'react';
import {
  MarketingLayout,
  Section,
  Hero,
  FeatureGrid,
  CallToAction,
} from '@byscott-io/corebyscott';

const features = [
  {
    icon: '🔗',
    title: 'Share your link',
    description: 'Get a unique referral link and share it anywhere — posts, emails, videos, your site.',
  },
  {
    icon: '💸',
    title: 'Earn recurring commission',
    description: 'When someone subscribes through your link, you earn — and keep earning while they stay.',
  },
  {
    icon: '📊',
    title: 'Track everything',
    description: 'Watch referrals, pending earnings, and payouts add up in real time on your dashboard.',
  },
  {
    icon: '🆓',
    title: 'Free to join',
    description: 'No cost, no quotas, no commitment. Apply, get approved, start sharing.',
  },
  {
    icon: '✋',
    title: 'Reviewed by hand',
    description: 'Every application is reviewed personally — usually within a day or two.',
  },
  {
    icon: '🔐',
    title: 'Passwordless sign-in',
    description: 'No passwords to manage. Sign in any time with a one-time magic link to your inbox.',
  },
];

export default function LandingPage() {
  return (
    <MarketingLayout>
      <Hero
        headline="Get paid to share apps you believe in"
        subheadline="Join the ByScott affiliate program. Refer customers to apps across the network and earn recurring commissions — free to join, no quotas."
        primaryCta={{ label: 'Apply to become an affiliate', href: '/signup' }}
        secondaryCta={{ label: 'How it works', href: '/help' }}
      />

      <Section background="gray">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900">How it works</h2>
          <p className="mt-4 text-lg text-gray-600">
            From application to your first payout, in a few simple steps.
          </p>
        </div>
        <FeatureGrid features={features} columns={3} />
      </Section>

      <CallToAction
        headline="Ready to start earning?"
        description="Apply in two minutes. We'll review your application and email you when you're approved."
        primaryCta={{ label: 'Apply now', href: '/signup' }}
        secondaryCta={{ label: 'Already an affiliate? Sign in', href: '/login' }}
      />
    </MarketingLayout>
  );
}
